function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import { countries } from '@noths/polaris-client-localisation';
import { currencies } from "../../../../content/currencies";
var COUNTRY_VALUE_SEPARATOR = '|';
export var encodeCountryValue = function encodeCountryValue(_ref) {
  var countryCode = _ref.countryCode,
    countryName = _ref.countryName,
    deliveryZone = _ref.deliveryZone;
  return [countryName, countryCode, deliveryZone].join(COUNTRY_VALUE_SEPARATOR);
};
export var decodeCountryValue = function decodeCountryValue(value) {
  var _value$split = value.split(COUNTRY_VALUE_SEPARATOR),
    _value$split2 = _slicedToArray(_value$split, 3),
    countryName = _value$split2[0],
    countryCode = _value$split2[1],
    deliveryZone = _value$split2[2];
  return {
    countryName,
    countryCode,
    deliveryZone
  };
};
var transformCountryToDropDownOption = function transformCountryToDropDownOption(_ref2) {
  var countryCode = _ref2.countryCode,
    deliveryZoneCode = _ref2.deliveryZoneCode,
    name = _ref2.name;
  return {
    optionValue: encodeCountryValue({
      countryName: name,
      countryCode,
      deliveryZone: deliveryZoneCode
    }),
    optionLabel: name
  };
};
var transformCurrencyToDropDownOption = function transformCurrencyToDropDownOption(_ref3) {
  var code = _ref3.code,
    symbol = _ref3.symbol;
  return {
    optionValue: code,
    optionLabel: "".concat(symbol, " ").concat(code)
  };
};
var getPlaceholderOption = function getPlaceholderOption(optionLabel) {
  return {
    optionValue: '',
    optionLabel,
    disabled: true
  };
};
export var countryOptions = [getPlaceholderOption('Select country')].concat(_toConsumableArray(countries.map(transformCountryToDropDownOption)));
export var currencyOptions = [getPlaceholderOption('Select currency')].concat(_toConsumableArray(currencies.map(transformCurrencyToDropDownOption)));